import React, { createContext, useContext } from "react";
import type { Tab } from "./tabs-context";

interface CurrentTabContextType {
	tab: Tab | null;
}

const CurrentTabContext = createContext<CurrentTabContextType | undefined>(undefined);

export const CurrentTabProvider: React.FC<{
	tab: Tab | null;
	children: React.ReactNode;
}> = ({ tab, children }) => {
	return (
		<CurrentTabContext.Provider value={{ tab }}>
			{children}
		</CurrentTabContext.Provider>
	);
};

export const useCurrentTab = () => {
	const context = useContext(CurrentTabContext);
	if (!context) {
		// Return null tab if not in context (e.g., when not rendered through TabContentRenderer)
		return { tab: null };
	}
	return context;
};